import { useTranslation } from 'react-i18next';

export function setupInterviewInitialValues(values, isPrimary = true){
  const {t} = useTranslation()
  let children_attributes = []
  values.job_meeting_details_attributes.map((x, index) => {
    let hash = {
      duration: x.duration,
      member_emails: x.member_emails || [],
      member_initials: x.member_initials || [],
      member_ids: x.member_ids || [],
      members: x.members || [],
      order: x.order,
      date: '',
      starttime: '',
      endtime: '',
      start_time: x.start_time || '',
      end_time: x.end_time || '',
      integration_id: x.meeting_platform_attributes?.integration_id || '',
      location: x.location || '',
      place_id: x.place_id || '',
      meeting_link: '',
      _destroy: x._destroy,
    }
    children_attributes.push(hash)
    return x;
  })
  let job_test_detail_attributes = {}
  if(values.job_test_detail_attributes){
    job_test_detail_attributes = setJobTestDetail(values.job_test_detail_attributes, t)
  }
  else{
    job_test_detail_attributes = defaultTestDetail([], [])
  }

  return {
    primary: isPrimary,
    interview_type_id: isPrimary ? values.interview_type_id : '',
    interview_type: isPrimary ? values.interview_type : '',
    default_location: isPrimary ? values.default_location : '',
    place_id: isPrimary ? values.place_id : '',
    date_range: true,
    children_attributes: isPrimary ? children_attributes : [],
    language: 'English',
    video_link: isPrimary ? values.video_link || '' : '',
    questions_attributes: isPrimary ? videoQuestions(values.questions_attributes) : [{question: '', description: '', attempts: 2, answer_time: 30, _destroy: false}],
    practise_screen: isPrimary ? values.practise_screen || false : false,
    expires: isPrimary ? values.expires || '' : '',
    job_test_detail_attributes: isPrimary ? job_test_detail_attributes : defaultTestDetail([], []),
    videoqa: {
      member_emails: values.members.map((x) => x.email) || [] ,
      member_initials: values.members || []
    }
  }


  function setJobTestDetail(job_test_detail_attributes){
    let value = job_test_detail_attributes

    if((job_test_detail_attributes.test_type == 'Assessment') && (job_test_detail_attributes.entity_type == 'JobStage'))
      {
        value.test_id = 'upload_new_test'
        value.test_name = t('modal:automation:upload_new_test')
      }
    if(!value.assessment) value.assessment =  {
      name: '',
      file_type: 'link',
      link: '',
      file: '',
      filename: '',
      filesize: '',
    }
    delete value['id']
    return value
  }

  function defaultTestDetail(member_emails, member_initials){
    return {
      "test_id": '',
      "test_type": 'TestLibrary',
      "days_to_expire": '',
      "member_emails": member_emails || [],
      "member_initials": member_initials || [],
      "assessment": {
        name: '',
        file_type: 'link',
        link: '',
        file: '',
        filename: '',
        filesize: '',
      }
    }
  }

  function videoQuestions(questions_attributes){
    let questions =[]
    questions_attributes.map((question, index) => {
      questions.push({
        "question": question.question || '',
        "description": question.description || '',
        "attempts": question.attempts || '',
        "answer_time": question.answer_time || '',
        "_destroy": false
      })
      return question
    })
    return questions
  }
}